// extracted by mini-css-extract-plugin
export var container = "_ev-0";
export var icon = "_ev-1";
export var text = "_ev-2";